module.exports = __webpack_public_path__ + "static/x45-ca89109520b2469115c07475d8640e60.png";